<template>
  <footer class="page-footer">
    <div class="container">
      <div class="page-footer-content">
        <nav class="nav-page-footer-box">
          <ul class="nav nav-page-footer">
            <li>
              <a href="https://www.enea.pl" target="_blank">Przejdź do portalu Enea</a>
            </li>
            <li>
              <a href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf" target="_blank" rel="noreferrer">Polityka prywatności</a>
            </li>
          </ul>
        </nav>
        <div class="page-footer-copy">
          &copy; Autopay S.A
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>
